// eslint-disable-next-line import/extensions
import services from '../services/member.js'
import { message } from 'antd'
import { exportStreamFiles } from '@/utils/utils'

const {
  editBasicInfo,
  editOtherInfo,
  uploadLogo,
  memberPayment,
  getPaymentList,
  getMemberList,
  saveUploadfiles,
  completeReport,
  downloadTemplate,
  uploadApplication,
  uploadBusinessLicense,
  uploadQualificationFiles,
  changeCredential,
  saveMemberUserChange,
  getMemberUserChange,
} = services

const namespace = 'member'

export default {
  namespace,
  state: {
    componenyFiles: [],
    qualificationFiles: [],
    paymentList: [], // 缴费历史
    membershipList: [], // 历史会员证
    changedInfo: {
      auditStatus: undefined, // 0 待审批 1 审批通过 -1审批驳回
    }, // 变更记录
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *update({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 编辑基本信息
    *editBasicInfo({ payload, callback }, { call }) {
      const res = yield call(editBasicInfo, { ...payload })
      if (res.success) {
        message.success('编辑成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 编辑其他信息
    *editOtherInfo({ payload, callback }, { call }) {
      const res = yield call(editOtherInfo, { ...payload })
      if (res.success) {
        message.success('编辑成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 上传企业Logo
    *uploadLogo({ payload, callback }, { call }) {
      const res = yield call(uploadLogo, { ...payload })
      if (res.success) {
        message.success('上传成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 添加缴费信息
    *memberPayment({ payload, callback }, { call }) {
      const res = yield call(memberPayment, { ...payload })
      if (res.success) {
        message.success('上传成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 查看历史缴费记录
    *getPaymentList({ payload, callback }, { call, put }) {
      const res = yield call(getPaymentList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentList: {
              ...res.data,
            },
          },
        })
      } else {
        message.error(res.globalError)
      }
    },

    // 查看历史会员证
    *getMemberList({ payload, callback }, { call, put }) {
      const res = yield call(getMemberList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            membershipList: {
              ...res.data,
            },
          },
        })
      } else {
        message.error(res.globalError)
      }
    },

    // 保存上报文件
    *saveUploadfiles({ payload, callback }, { call, put }) {
      const res = yield call(saveUploadfiles, { ...payload })
      if (res.success) {
        message.success('保存成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 完成上报
    *completeReport({ payload, callback }, { call, put }) {
      const res = yield call(completeReport, { ...payload })
      callback && callback(res)
      if (res.success) {
        message.success('上报成功')
      } else {
        message.error(res.globalError)
      }
    },

    // 入会申请表模板下载
    *downloadTemplate({ payload, callback }, { call, put }) {
      const res = yield call(downloadTemplate, { ...payload })
      exportStreamFiles(res, '入会申请表模版.doc')
    },

    // 入会申请表模板上传
    *uploadApplication({ payload, callback }, { call, put }) {
      const res = yield call(uploadApplication, { ...payload })
      if (res.success) {
        message.success('上传成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 上传企业营业执照
    *uploadBusinessLicense({ payload, callback }, { call, put }) {
      const res = yield call(uploadBusinessLicense, { ...payload })
      if (res.success) {
        message.success('上传成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 上传资质文件
    *uploadQualificationFiles({ payload, callback }, { call, put }) {
      const res = yield call(uploadQualificationFiles, { ...payload })
      if (res.success) {
        message.success('上传成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 换证申请
    *changeCredential({ payload, callback }, { call, put }) {
      const res = yield call(changeCredential, { ...payload })
      if (res.success) {
        message.success('申请成功')
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 企业信息变更
    *saveMemberUserChange({ payload, callback }, { call }) {
      const res = yield call(saveMemberUserChange, { ...payload })
      if (res.success) {
        callback && callback()
      } else {
        message.error(res.globalError)
      }
    },

    // 企业信息变更
    *getMemberUserChange({ payload, callback }, { call, put }) {
      const res = yield call(getMemberUserChange, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            changedInfo: {
              ...res.data,
            },
          },
        })
        callback && callback(res.data)
      } else {
        message.error(res.globalError)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
